import styled from 'styled-components';
import '@splidejs/splide/dist/css/splide-core.min.css';
import {
  SYS_BORDER_RADIUS_MD,
  SYS_PAGE_MARGIN,
  SYS_SPACE_FIXED_100,
  SYS_SPACE_FIXED_200,
  SYS_SPACE_FIXED_300,
  SYS_SPACE_FIXED_400,
  SYS_SPACE_RELATIVE_LG,
  SYS_SPACE_RELATIVE_XL,
} from '@oneaudi/unified-web-common';

const isLegacy = process.env.IS_LEGACY;

export const Div = styled.div`
  .faCarousel__cta {
    margin: 0 0 ${SYS_SPACE_FIXED_200} 0;
  }
  .splide__list {
    display: flex;
    list-style-type: none;
    margin: 0;
    padding: 0;
  }
  .faCarousel {
    padding-bottom: ${SYS_SPACE_RELATIVE_XL};
  }
  .faCarousel--dark {
    background-color: #000;
  }
  .faCarousel--light {
    background-color: #fff;
  }
  .faCarousel__title {
    display: flex;
    width: 100%;
    align-items: flex-start;
    box-sizing: border-box;
  }
  .faCarousel__title--unset {
    min-height: ${SYS_SPACE_RELATIVE_XL};
  }
  .faCarousel__title--set {
    padding: ${SYS_SPACE_RELATIVE_XL} ${SYS_PAGE_MARGIN} ${SYS_SPACE_RELATIVE_XL};

    @media (max-width: 374px) {
      padding: ${SYS_SPACE_RELATIVE_XL} ${SYS_PAGE_MARGIN} ${SYS_SPACE_RELATIVE_XL};
    }
    @media (min-width: 375px) and (max-width: 767px) {
      padding: ${SYS_SPACE_RELATIVE_XL} ${SYS_PAGE_MARGIN} ${SYS_SPACE_RELATIVE_XL};
    }
    @media (min-width: 768px) and (max-width: 1023px) {
      padding: ${SYS_SPACE_RELATIVE_XL} ${SYS_PAGE_MARGIN} ${SYS_SPACE_RELATIVE_XL};
    }
    @media (min-width: 1024px) and (max-width: 1439px) {
      padding: ${SYS_SPACE_RELATIVE_XL} ${SYS_PAGE_MARGIN} ${SYS_SPACE_RELATIVE_XL};
    }
  }
  .faCarousel__slide {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
  .faCarousel__image {
    width: 100%;
    aspect-ratio: 1/1;
    object-fit: cover;
  }
  .faCarousel__video {
    border-radius: ${isLegacy ? '0' : SYS_BORDER_RADIUS_MD};
    overflow: hidden;
    div {
      height: auto;
    }
  }
  .faCarousel--light .faCarousel__image,
  .faCarousel--light .faCarousel__video {
    background-color: #f2f2f2;
    color: #1a1a1a;
  }
  .faCarousel--dark .faCarousel__image,
  .faCarousel--dark .faCarousel__video {
    background-color: #2a2a2a;
    color: #ffffff;
  }
  .faCarousel__copy {
    display: flex;
    flex-direction: column;
    gap: ${SYS_SPACE_FIXED_100};
    max-width: 549px;
    padding: ${SYS_SPACE_FIXED_300} 0 0;
  }
  /* .faCarousel__copy:has(ul) {
    padding-bottom: ${SYS_SPACE_RELATIVE_LG};
  } */

  .faCarousel__slideFootnote {
    letter-spacing: 0.002px;
    font-size: 12px;
    line-height: 166.667%;
  }
  .faCarousel__paginationContainer {
    padding-top: ${SYS_SPACE_FIXED_300};
    padding-bottom: ${SYS_SPACE_RELATIVE_LG};
    margin-right: ${SYS_PAGE_MARGIN};

    display: flex;
    flex-direction: column;
    align-items: flex-end;
    ${!isLegacy &&
    ` button {
      display: flex;
      padding: 0px;
      -moz-box-align: center;
      align-items: center;
      -moz-box-pack: center;
      justify-content: center;
      border-radius: 999px;
      transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
      transition-duration: 250ms;
      transition-property: color, box-shadow, border-color, background;
      cursor: pointer;
      width: 56px;
      height: 56px;
      background: rgb(101, 112, 129);
      color: rgb(252, 252, 253);
      border: 1px solid rgba(101, 112, 129, 0);
    }

    button:disabled,
    button[disabled] {
      background: rgba(77, 87, 102, 0.5);
      color: rgba(154, 163, 177, 0.3);
      cursor: not-allowed;
    }
`}
  }
  .faCarousel__paginationContainer--hidden {
    display: none;
  }
  @media (min-width: 375px) and (max-width: 767px) {
    .faCarousel__paginationContainer {
      padding-top: ${SYS_SPACE_FIXED_300};
      padding-bottom: ${SYS_SPACE_RELATIVE_LG};
    }
  }
  @media (min-width: 768px) and (max-width: 1023px) {
    .faCarousel__paginationContainer {
      padding-top: ${SYS_SPACE_FIXED_400};
      padding-bottom: ${SYS_SPACE_RELATIVE_LG};
    }
    .faCarousel__paginationComponent {
      margin-right: ${SYS_PAGE_MARGIN};
    }
  }
  @media (min-width: 1024px) and (max-width: 1439px) {
    .faCarousel__paginationContainer {
      padding-top: ${SYS_SPACE_FIXED_400};
      padding-bottom: ${SYS_SPACE_RELATIVE_LG};
    }
    .faCarousel__paginationComponent {
      margin-right: ${SYS_PAGE_MARGIN};
    }
  }
  @media (min-width: 1440px) and (max-width: 1919px) {
    .faCarousel__paginationContainer {
      padding-top: ${SYS_SPACE_FIXED_400};
      padding-bottom: ${SYS_SPACE_RELATIVE_LG};
    }
    .faCarousel__paginationComponent {
      margin-right: ${SYS_PAGE_MARGIN};
    }
  }
  @media (min-width: 1920px) {
    .faCarousel__paginationContainer {
      padding-top: ${SYS_SPACE_FIXED_400};
      padding-bottom: ${SYS_SPACE_RELATIVE_LG};
    }
    .faCarousel__paginationComponent {
      margin-right: ${SYS_PAGE_MARGIN};
    }
  }

  @media (min-width: 768px) {
    .faCarousel__paginationContainer {
      align-items: flex-end;
    }
  }
`;
